const ResultBlock = ({resultCode}) => {
    console.log(resultCode === "200");
    return (
        <>
            {resultCode === 200 ? (
                <div className="tw-flex tw-flex-col tw-items-center tw-gap-6 tw-self-center tw-w-[342px]">
                    <img width="88" height="88" src="/o/mutelios-theme-css/icons/CheckOrange.svg" alt=""/>
                    <span className="tw-text-sm-body-lead lg:tw-text-body-lead tw-text-center">Votre demande de devis a bien été prise en compte. Nous allons vous recontacter prochainement</span>
                </div>) : (<div className="tw-flex tw-flex-col tw-items-center tw-gap-6 tw-self-center tw-w-[342px]">
                <span className="tw-text-sm-body-lead lg:tw-text-body-lead tw-text-center">Une erreur s'est produite, veuillez contacter le service client</span>
            </div>)}
        </>
    );
};

export default ResultBlock;
